<template>

</template>

<script>
  export default {
    computed: {
      canEditRetend() {
        return this.retend.permissions.CAN_EDIT_RETEND;
      }
    }
  }
</script>

<style scoped>

</style>
